<template>
<div>
  <CountryView  />
    <section class="term">
        <div class="termson">
     <h2 class="question">Terms and Conditions</h2>
     <p class="termp">
        <b class="">1. TERMS</b> <br><br>
       1.1 Terms and conditions for users otherwise referred to as Terms of Use, the terms “we”,
        “our”, “us” means SwyChr Technology Africa Limited and her partners,
        employees, officers, agents, affiliates or assigned parties.<br><br>

        1.2  “Website” refers to www.swychr.com<br><br>

        1.3 By gaining access and using this Website and/or our mobile app, you agree to abide to these
        Terms of Use, the Privacy Policy and all applicable laws and regulations, and agree that you are
        responsible for compliance with any applicable local laws. However, if you do not agree with any
        of these Terms, your only option is to stop using the Website and/or our mobile app. All materials
        contained in this Website and/or our mobile app are protected by applicable copyright and trademark<br><br>
        law.

      1.4 Individuals under the age of (18) years may not use the website or mobile app and may not accept 
      these Terms of Use if they cannot obtain the permission of a parent or guardian.<br><br>
      
      1.5 By agreeing to these terms and conditions within this document you accept expressly
       all terms or you accept 
      by default if you use this website or our mobile app.<br><br>

       <b class="">2. LICENSE USE & RESTRICTIONS</b> <br><br>

       2.1 Permission is granted to temporarily download materials on the Website for personal,
        non-commercial
        viewing only. However, you may not:<br><br>
      - Modify or copy the materials and / or use for commercial purpose or for public display
       (commercial or not);<br>
      - Attempt to duplicate any part of the software applications contained on the Website or\
       our mobile app;<br>
      - Remove any copyright or other proprietary notations from the materials;<br>
      - Transfer the materials to another person or “mirror” the materials on any other server.<br><br>

      2.2 By using our Website and/or mobile app you irrevocably agree and undertake to ensure that you
       will not:<br><br>
      -Use any automated device, software process or means to access, retrieve, scrape, or index our 
      Website,
       mobile app or any content on our Website and/or mobile app;<br>
      -Use any device, software, process or means to interfere or attempt to
       interfere with the proper working on our Website and/or mobile app;<br>
      -Undertake any action that will impose a burden on our infrastructure that we deem, in our 
      sole discretion to be unreasonable or disproportionate Website and/or mobile app usage <br>
      -Use or index any content or data on our Website or mobile app for purposes of: <br>
      -Constructing or populating a searchable database of fintech related businesses,  <br>
      -Building a database of fintech and blockchain; or <br>
      -Competing with us in any manner that we have not specifically authorized;<br>
      -Transmit spam, chain letters, contents, junk email, surveys, or other mass messaging,
       whether commercial in nature or not;<br>
      -Use our Website, mobile app or any content from our Website and mobile app in any manner
       which we in our sole discretion determine as not reasonable and/or not for the purpose 
       which it is made available; <br>
      -Violate the rights of any person, including copyright, trade secret, privacy right,
       or any other intellectual property or proprietary right;<br>
      -Reproduce, republish, retransmit, modify, adapt, distribute, translate, create derivative
       works or adaptation of, publicly display, sell, trade, or in any way exploit our Website,
       mobile app or any content on our Website, except this is expressly authorized by us; or<br>
      -Transmit or attempt to transmit any computer viruses, worms, defects or other items of a destructive manner.<br><br>
       
      2.3 We reserve the right to exercise whatever means we deem necessary to prevent unauthorized access or use of the Website
       and mobile app, including but not limited to, instituting technological barriers, or reporting your conduct to any person or entity.<br><br>

      2.4 This license shall automatically terminate if you violate any of these restrictions and may be terminated by us at any time. Upon terminating 
      your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in 
      electronic or printed format.<br><br>
  
      <b class="">3. YOUR RESPONSIBILITIES</b> <br><br>

      3.1 SwyChr Technology Africa Limited is not a bank nor a financial institution and only provides a service whereby individuals conveniently remit
       value through the use of our digital currency dubbed “Purple Coins”  or any other token we see fit for this purpose both locally and internationally.
        We are able to do this in most cases by working with a combination of both 3rd parties and/or the approved authorities depending on the region and 
        applicable regulations in place in any particular region at any point in time.<br><br>

      3.2 Details are hosted by us in good faith but are produced directly/availed from the appropriate authorities
       and/or third parties. You are responsible for making your own enquiries and we provide no guarantee 
       and accept no responsibility for the accuracy or completeness of any information contained within our
        platforms (website and app).<br><br>
        
      3.3 You remain responsible for verifying, confirming and ensuring accuracy of any Details while using
       our website and/or mobile app.<br><br>
       
      3.4 You are responsible for carrying out your own independent verification before committing to any
       transaction on our platforms.<br><br>
       
      3.5 You are responsible for ensuring that you act in good faith towards any other parties.<br><br>
      
      3.6 You represent and warrant that your use of our Website and mobile app will comply at all times
       with these Terms of Use and any further terms that may apply to you in relation to your use of our
        Website or mobile app, including all amendments and revisions to these Terms in accordance with
         the applicable Clause contained herein;<br><br>

     <b class="">4. LIMITATIONS OF USE</b> <br><br>

     4.1 Under no circumstance will we be liable for damages (including, but not limited to damages for loss
      of data or profit, or due to business interruption) arising out of the use or inability to use the materials 
      on the Website and or mobile app.<br><br>

     4.2 We will not be liable for any loss or damage arising under or in connection with:<br><br>
     
     -Any failures due to software or internet errors or unavailability, 
     or any other circumstances beyond our reasonable control;<br>
     -Any loss of your password or account if caused by a breakdown, error,
      loss of power or otherwise caused by or to your computer system and/or your account;<br>
     -The use of, or inability to use, our website and mobile app;<br>
     -The reliance on any content portrayed on our website and or mobile app;<br>
     -Any direct, consequential, special or punitive loss, damage, costs and expenses;<br>
     -Loss of profit, business, reputation;<br>
     -Damage to or corruption of data.<br><br>
     
     4.3 Unless we otherwise expressly agree in writing, you agree not to use our mobile app or website 
     for any commercial or business purposes over and above the manner specified in these Terms of Use.<br><br>

     4.4 We will not be liable for any loss or damage caused by a virus, distributed denial of service attack or
      other technologically harmful material that may infect your mobile phone, computer equipment, computer programs,
       data as a result of using our mobile app, website or to your downloading of any content on it, or any website or 
       app linked to it.<br><br>

    <b class="">Revisions and Errata</b> <br><br>   

    The materials appearing on the Website and mobile app could include technical, typographical, or photographic errors. 
    We do not warrant that any of the materials on this Website and mobile app are accurate, complete, or current. We may
     make changes to the materials contained on the Website or app at any time without notice. <br><br> 
 
    <b class="">Website and Mobile App Availability</b><br><br> 

    We strive to ensure that our mobile app or website and the services offered are available to you at all times but 
    cannot guarantee that either the Website or the services will operate continuously, without interruptions or be fault
    free. On occasion, necessary maintenance or upgrade work requires us to make the Website or mobile app and the services
     unavailable without notice, but we aim to keep downtime to a minimum. We accept no liability for any interruption or
      loss of service. We reserve the absolute right to alter, suspend or discontinue any part of our mobile app or website
       or the services, including your access to it.<br><br> 

    <b class="">Third Party Dealings and Links</b><br><br> 

    Our website and mobile app may contain links, hyperlinks and pointers to third party products, services and/or websites
     that are not directly affiliated with us. We therefore cannot guarantee or take responsibility for them. Our Website or 
     mobile app may also contain advertising from third parties and we are not responsible, nor do we make any warranties or
      representations for any misleading or inaccurate advertisements which are the sole responsibility of the advertiser.<br><br> 

   Any links or advertisements on our Website or mobile app should not be taken as an endorsement by us of any kind. Furthermore
    our mobile app or website contains data provided by third parties and we accept no responsibility, nor do we make any warranties
     or representations for any inaccuracies in this material. You agree to release us from any claims or disputes of any kind arising
     from or in any way connected to such disputes with third parties.<br><br> 

   By using the mobile app and/or website, you grant us an irrevocable, world-wide, royalty free license to commercialize, copy, license
    to other persons, use and adapt for any purpose any material you generate or submit to make use of the Website or mobile app. We do 
    not warrant that the content, links, or sub-domains contained on, or associated with our Website and our mobile app will be available
     and accessible to you at all times. Information on our publications, posts, inserts, information, content should not be regarded as
      a substitute for professional legal, financial travel consultancy advice. <br><br> 
      
        <b class="">Site Terms of Use Modifications</b><br><br> 

     We may revise these Terms of Use and any such Terms for the Website and mobile app at any time without notice. By using this
    Website or mobile app, you are agreeing to be bound by the Terms of Use. <br><br> 
    
      <b class="">5. CONTRIBUTIONS</b><br><br> 

      5.1 In these Terms of Use “Contributions” means any information including data, text, video,
       still images, audio or other material that we have permitted you to host, share, publish,
       post, store or upload on our Website or mobile app.<br><br> 

      5.2 We may at any time, without liability to you, remove, alter or disable access to any or all of
       your Contributions in our sole discretion without prior notice to you. Without limiting the previous 
      sentence, we may remove or disable access to any or all of your Contributions if we consider that:<br><br> 

      -Those Contributions are in breach of any law or regulation;<br>
      -Those Contributions infringe the intellectual property rights of any third party;<br>
      -It is required to do so by a regulatory body or any relevant authority pursuant to an 
      interim or final take-down notice;<br>
      -Those Contributions are misleading or deceptive;<br>
      -Inappropriate in regards to the purpose of our mobile app or website;<br>
      -Offensive, materially incorrect, obscene or defamatory;<br>
      -Unlawful and/or against the customs or norms of the region in which 
      this Website and mobile app is referred too; or<br>
      -Corrupted, due to the presence of a virus or other disabling code.<br><br>

      5.3 To the extent that any Contributions are proprietary in nature, you
       grant us a worldwide, non-exclusive, royalty-free, perpetual, transferable 
       and irrevocable license to use, reproduce, modify, adapt, translate, distribute, 
       publish, create derivative works from and display and publicly perform your 
       Contributions throughout the world in any medium, whether currently in existence or not.<br><br>

       5.4 You also grant each user of our mobile app and/or website the right to use your name or the 
       name you submit with the Contribution, and, the right to represent and warrant that:<br><br>

       -You own and control all of the rights to the Contributions; or<br>
       -You have the lawful right including all necessary licenses, rights, consents 
       and permissions to use and authorize us to display the Contributions.<br><br>

       For any Contributions that you may retain moral rights in, you declare that:<br><br>

       -You do not require that any personally identifying information be used in connection
        with the Contribution, or any derivative work, upgrade or update of the Contribution; and<br>
       -You understand that when accessing our Website and mobile app, you may be exposed to the
        Contributions of other users of our platforms. You acknowledge and agree that we do not
         have control of and are not responsible nor do we warrant the veracity of these other 
         Contributions.<br><br>

       5.6 You represent and warrant that:<br><br>
       
       -You have the lawful right including all necessary licenses, rights, consents and permissions
        to use and authorize us to display your Contributions;<br>
       -You will not make any Contributions that infringe the intellectual property rights of any 
       third party, and you agree to pay all royalties, fees or other monies payable by reason
        of any Contributions made by you; and<br><br>

      You will not make any Contributions that:<br><br>
      
       -Are misleading, deceptive and / or materially incorrect;<br>
       -Are likely to cause offence or defamatory;<br>
       -Directly or indirectly involve the advertising or marketing of any products or services;<br>
       -Are obscene, including pornographic, hateful, racially or ethnically offensive material;<br>
       -Are otherwise unlawful or encourage unlawful conduct; or inappropriate.<br><br>

        <b class="">6. INTELLECTUAL PROPERTY RIGHTS</b><br><br> 

        6.1 Except in case where it is expressly stated, all contents of the mobile app 
        and website are copyrights, trademarks, intellectual property owned, controlled
         or licensed by us, our affiliates or by third parties who have licensed their
         materials to us and are protected by the applicable laws.<br><br> 

        6.2 We, together with our suppliers and licensors expressly reserve all
         intellectual property rights in all text, programs, products, processes,
          technology, content and other materials, which appear on this Website 
          and mobile app. Access to our mobile app and website does not confer and
           shall not be considered as conferring upon anyone any license under any 
           of our or any third party’s intellectual property rights. Any use of our
            app and website or its contents, including copying or storing it or them 
            in whole or part, other than for personal, non-commercial use, is prohibited
             without our permission. You may not modify, distribute or re-post anything on 
             our app or website for any purpose. <br><br>
             
          6.3 Our names and logos and all related product and service names, design marks 
          and slogans are our trade or service marks or our licensors. No trademark or 
          service mark license is granted in connection with the materials contained on
           this Website or within our mobile application.<br><br>

          <b class="">7. ELECTRONIC COMMUNICATIONS</b><br><br>   

          7.1 By using SwyChr Technology Africa Limited’s platforms website and mobile 
          app or in sending us emails, you are communicating with us electronically. 
          You consent to receive electronically any communications related to your use 
          of our platforms. We will communicate with you by email or by posting notices
           on this Website, our app or on other social media pages. You agree that all 
           agreements, notices, disclosures and other communications that are provided 
           to you electronically satisfy any legal requirement that such communications
            be in writing. All notices from us intended for receipt by you shall be deemed
             delivered and effective when sent to the email address you provide on the
              Website for your account.<br><br>  
        
          <b class="">8. INDEMNITY</b><br><br>   
          
        8.1 By using our website and mobile app, you agree to indemnify us and our affiliates
         (our officers, agents, partners) against any and all loss, liability, claim or demand,
          including reasonable attorney’s fees, arising out of, or in connection with your use
           of and access to our mobile app and website or making Contributions not in accordance
            with the Terms.<br><br>
            
      8.2 For all remittances made through our app, our partners settle the same following guidance
       provided by the appropriate regulatory authorities. In case of any rejection or delay due to 
       any reason, we or our partners will not be responsible for refund or retrieval of the amount 
       remitted especially if withheld by the authorizes.<br><br>

      <b class="">Disclaimer</b><br><br>  

      The materials on our Website and mobile app are provided on an “as is” and “as available” basis
       and we make no warranties, expressed or implied, and hereby disclaim and negate all other 
       warranties, including without limitation, implied warranties or conditions of merchantability,
        fitness for a particular purpose, or non-infringement of intellectual property or other 
        violation of rights. Further, we do not warrant or make any representation concerning the 
        accuracy, likely results, or reliability of the use of the materials on the Website or 
        otherwise relating to such materials or on any site linked to this Website.<br><br> 

       Also, you indemnify us from any loss or misappropriation arising from monetary 
       transactions between you and any third party contacted via our website or mobile 
       app be it an agent, appropriate authority or any other third party as we cannot
        authenticate, guarantee or are we directly involved in such a transaction. You
         personally have it a duty to check accuracy of any such demands before payment.<br><br> 
         
        <b class="">9. GOVERNING LAW</b><br><br>  
        
        9.1 These Terms of Use and your access to the mobile app and website is subject to 
        and governed by the laws of the Republic of Cameroon. You agree to submit to the
         exclusive jurisdiction of the Courts of the Republic of Cameroon.<br><br>  

        9.2 If any term of the Agreement is or may become for any reason invalid or 
        unenforceable at law, the validity and enforceability of the remainder will not be affected.<br><br> 

           <b class="">10. CONTACT US</b><br><br>

        10.1 Our official website is: www.swychr.com. We only provide information that are relevant to
         local and cross boarder remittances and other services as maybe be added from time to time. 
         To report any suspected misleading service or package offering on our site or mobile app please 
         send us an email with the details to: info@swychr.com<br><br>

         If you have any queries, complaints, or recommendations about these
          Terms of Use, please contact us by email at: info@swychr.com
     </p>
    </div>
    </section>

    <FooterView />
</div>
 </template>

  <script  setup>
import CountryView from '@/components/CountryView.vue';
import FooterView from '@/components/FooterView.vue';   
 </script>

 <style>
  .question{
  text-align: justify;
   color: black;
   font-size: 70px;
   font-weight: 700;
   padding-bottom: 100px;
   margin-top: 30px;
   margin-left: 0;
   font-family: 'Montserrat', sans-serif;
}  

.term{ 
  text-align: center;
  margin: 0 auto;
  padding: 0.625rem 0;
  height: auto;
  position: relative; 
  width: 100%;
  align-items: center;
  justify-content: center;
}

.termson{
  padding-top: 3rem; 
  display: block;
  align-items: center;
  justify-content: center;
  margin-top: 0;
  width: 95vw; 
}

.termp{
  text-align: justify;
  line-height: 1;
  margin-left: 6.61vw; 
  width: 93%;
}
 </style>